import React from 'react'
import { useRef } from 'react'
import useIntersectionObserver from '@react-hook/intersection-observer'

function youtube_parser(url) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);
  return (match && match[7].length == 11) ? match[7] : false;
}

const SingleVideo = ({ url, title }) => {
  const containerRef = useRef()
  const lockRef = useRef(false)
  const { isIntersecting } = useIntersectionObserver(containerRef)
  if (isIntersecting) {
    lockRef.current = true
  }
  const videoId = youtube_parser(url)
  let embed_url = `https://www.youtube.com/embed/${videoId}`
  return (
    <div
      style={{
        overflow: 'hidden',
        paddingTop: '56.25%',
        position: 'relative',
        width: '100%',
      }}
      ref={containerRef}
    >
      {lockRef.current && (
        <iframe
          title={title}
          style={{
            bottom: 0,
            height: '100%',
            left: 0,
            position: 'absolute',
            right: 0,
            top: 0,
            width: '100%',
          }}
          src={embed_url}
          frameBorder="0"
          allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen="allowfullscreen"
        ></iframe>
      )}
    </div>
  )
}

export default SingleVideo